module.exports = __webpack_public_path__ + "img/dante-canto-menu.ba116b5b.jpg";